import Box from '@components/Box';
import PlacingOrderTitle from './PlacingOrderTitle';
import TextInputContainer from '@containers/TextInputContainer';
import { Column, Row } from '@components/Grid';
import { IPlacingOrderAddressEnglishProps } from '../types';
import { useTranslation } from 'react-i18next';

const PlacingOrderAddressEnglish: React.FC<IPlacingOrderAddressEnglishProps> = (props: IPlacingOrderAddressEnglishProps): React.ReactElement => {
  const { control } = props;

  const { t } = useTranslation();

  return (
      <>
        <PlacingOrderTitle title={t('placingOrderModalWindow.form.addressEnglish.title')}/>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <TextInputContainer
                  control={control}
                  name="addressEnglish.city"
                  title={t('placingOrderModalWindow.form.addressEnglish.city')}
                  maxLength={35}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={6}>
            <Box
                mb={5}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  name="addressEnglish.street"
                  title={t('placingOrderModalWindow.form.addressEnglish.street')}
                  maxLength={150}
              />
            </Box>
          </Column>
          <Column phone={3}>
            <Box
                mb={5}
                pr={4}
            >
              <TextInputContainer
                  control={control}
                  name="addressEnglish.house"
                  title={t('placingOrderModalWindow.form.addressEnglish.house')}
              />
            </Box>
          </Column>
          <Column phone={3}>
            <Box mb={5}>
              <TextInputContainer
                  control={control}
                  name="addressEnglish.flat"
                  title={t('placingOrderModalWindow.form.addressEnglish.flat')}
              />
            </Box>
          </Column>
        </Row>
      </>
  );
};

export default PlacingOrderAddressEnglish;